import { module } from 'angular';
import { PaymentProcessComponent, PaymentRedirectComponent } from './components';
import { paymentProcessFormDirective } from './directives/payment-process-form.directive';
import { paymentProcessRoutesConfig } from './payment-process-routing';

export const PaymentProcessModule = module('app.mobile.state.payment-process', [])
  .component('paymentProcess', PaymentProcessComponent)
  .component('paymentRedirect', PaymentRedirectComponent)
  .directive('paymentProcessForm', paymentProcessFormDirective)
  .config(paymentProcessRoutesConfig);



// WEBPACK FOOTER //
// ./app/states_mobile/payment-process/payment-process.module.ts